import ArrowLeft from "components/Icons/ArrowLeft";
import React from "react";

const Breadcrumbs = ({ title, link }) => {
  return (
    <div className="max-md:text-center flex space-x-2 my-5 md:my-8 items-center px-5 text-[#1F2937] font-bold text-2xl">
      {link && <ArrowLeft className="size-10" />}
      <span className="text-2xl">{title}</span>
    </div>
  );
};

export default Breadcrumbs;
